import { render, staticRenderFns } from "./ConversationViewer.vue?vue&type=template&id=0fa041d6&scoped=true"
import script from "./ConversationViewer.vue?vue&type=script&lang=js"
export * from "./ConversationViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa041d6",
  null
  
)

export default component.exports